<template>
  <el-dialog
    :visible.sync="state"
    :append-to-body="true"
    custom-class="complete-item-select">
    <v-complete-item-list/>
  </el-dialog>
</template>



<script>
import {
  Dialog,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/dialog.css'
import 'element-ui/lib/theme-chalk/icon.css'

export default {
  components: {
    'el-dialog': Dialog,
    'v-complete-item-list': require('@/components/complete-item-list.vue').default,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
  }
}
</script>



<style lang="scss">
.complete-item-select {
  width: 608px;

  .el-dialog {
    &__body {
      padding: 0;
      @include breakpoints-min(md) {
        padding: 32px 0;
      }
    }
  }
}
</style>
